import MenuBar from '../organisms/menu_bar'
import AuthenticationWrapper from '../organisms/authentication_wrapper'
import { useState } from 'react'
import SiteHeader from '../organisms/site_header'
import Layout, { Content, Header } from 'antd/lib/layout/layout'
import Sider from 'antd/lib/layout/Sider'

export default function LoggedInTemplate(props: any) {
    const [collapsed, setCollapsed] = useState(false)
    return (
        <div style={{ display: 'flex', height: '100%' }}>
            <Layout>
                <Header style={{ paddingLeft: '25px', paddingRight: '25px' }}>
                    <Content>
                        <SiteHeader
                            loggedIn={true}
                            collapsed={collapsed}
                            setCollapsed={setCollapsed}
                        />
                    </Content>
                </Header>
                <Layout style={{height: '100%'}}>
                    <Sider
                        collapsed={collapsed}
                        breakpoint="sm"
                        style={{
                            overflowY: 'auto',
                        }}
                    >
                        <MenuBar
                            collapsed={collapsed}
                            setCollapsed={setCollapsed}
                        />
                    </Sider>
                    <Content style={{ padding: 20, overflow: 'auto' }}>
                        <AuthenticationWrapper>
                            {props?.children}
                        </AuthenticationWrapper>
                    </Content>
                </Layout>
            </Layout>
        </div>
    )
}
